// Copyright (c) 2016 Deere & Company

import ClaimsStatus, {getDefaultState as getClaimsStatusDefaultState} from './claims-status';
import t from 'tcomb';

const ClaimsSettings = t.struct({
    numberOfDays: t.Number,
    status: ClaimsStatus
}, {
    name: 'ClaimsSettings',
    strict: true
});

export const getDefaultState = () => new ClaimsSettings({
    numberOfDays: 0,
    status: getClaimsStatusDefaultState()
});

export default ClaimsSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claims-settings.js